import React, { Component } from "react";
import ReactDOM from "react-dom";
import Location from "./Steps/Location";
import Progress from "./UI/Progress";
import Move from "./Steps/Move";
import Quote from "./Steps/Quote";
import Contact from "./Steps/Contact";
import Loading from "./Steps/Loading";
import Confirm from "./Steps/Confirm";
import { format } from "date-fns";
import Geocode from "react-geocode";
import WindowWarning from "./WindowWarning";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";

export default class OnlineBooking extends Component {
    constructor(props) {
        super(props);

        // Grab values
        const isDataByLMPID =
            document.getElementById("IsDataByLMPID")?.value === "True";
        const isIncompleteAddress = document.getElementById(
            "IsIncompleteAddress"
        )?.value;
        const errorMsg = document.getElementById("errorMsg")?.value;
        const movingFromInput = document.getElementById("MovingFromInput")?.value;
        let step1FormValidInit = false;
        let movingFromValidInit = true;
        let movingFromStreetErrMsgInit = "Please Enter Moving From Location.";

        // Step logic with if-else
        let initStep = 1;
        if (isDataByLMPID && isIncompleteAddress === "True") {
            initStep = 1;
        } else if (isDataByLMPID && isIncompleteAddress === "False") {
            initStep = 5;
        } else if (errorMsg) {
            initStep = 5;
        } else if (movingFromInput && !isIncompleteAddress) {
            initStep = 2;
        } else {
            initStep = 1;
        }

        if (isDataByLMPID || errorMsg) {
            step1FormValidInit = true;
        } else if (movingFromInput) {
            step1FormValidInit = true;
        } else if (isDataByLMPID && isIncompleteAddress) {
            step1FormValidInit = false;
        } else {
            step1FormValidInit = false;
        }

        if (isDataByLMPID && isIncompleteAddress) {
            movingFromValidInit = false;
            movingFromStreetErrMsgInit = "Please Enter Full Moving From Address.";
        }

        this.state = {
            LeadId: document.getElementById("LeadID").value
                ? document.getElementById("LeadID").value
                : "",
            isDataByLMPID:
                document.getElementById("IsDataByLMPID").value === "True" ||
                    document.getElementById("errorMsg").value
                    ? true
                    : false,
            isIncompleteAddress:
                document.getElementById("IsIncompleteAddress").value === "True"
                    ? true
                    : false,
            errorMsg: document.getElementById("errorMsg").value
                ? document.getElementById("errorMsg").value
                : "",
            step: initStep,
            isGoogleApiSetup: false,
            isFilled: false,
            checked: false,
            isLoading: true,
            movingFromStreet: document.getElementById("MovingFromInput").value
                ? document.getElementById("MovingFromInput").value
                : "",
            movingFromUnit: "",
            movingToStreet: document.getElementById("MovingToInput").value
                ? document.getElementById("MovingToInput").value
                : "",
            movingToUnit: "",
            movingDate: new Date(
                document.getElementById("MoveDate").value
                    ? document.getElementById("MoveDate").value
                    : +new Date() + 86400000
            ),
            houseSize: document.getElementById("HouseSize").value
                ? document.getElementById("HouseSize").value
                : "",
            movingVehicle: "",
            contactName: document.getElementById("ContactName").value
                ? document.getElementById("ContactName").value
                : "",
            contactEmail: document.getElementById("ContactEmail").value
                ? document.getElementById("ContactEmail").value
                : "",
            contactPhone: document.getElementById("ContactPhone").value
                ? document.getElementById("ContactPhone").value
                : "",
            appointmentType: "",
            appointmentDate: this.setFirstDay(),
            appointmentDateString: format(this.setFirstDay(), "MM/dd/yyyy"),
            appointmentTime: document.getElementById("AgentAppointmentStartDate")
                .value
                ? this.SetOperatingHoursByDay(
                    document.getElementById("AgentAppointmentStartDate").value
                )[0]
                : new Date(+new Date() + 86400000),
            appointmentTimeString: document.getElementById(
                "AgentAppointmentStartDate"
            ).value
                ? format(
                    this.SetOperatingHoursByDay(
                        document.getElementById("AgentAppointmentStartDate").value
                    )[0],
                    "hh:mm aa"
                )
                : format(new Date(+new Date() + 86400000), "MM/dd/yyyy"),
            agentAppointmentStartDate: new Date(
                document.getElementById("AgentAppointmentStartDate").value
                    ? document.getElementById("AgentAppointmentStartDate").value
                    : +new Date() + 86400000
            ),
            agentAppointmentNextHoliday:
                document.getElementById("AgentAppointmentNextHoliday").value || "",
            agentCode: document.getElementById("AgentCode").value
                ? document.getElementById("AgentCode").value
                : "",
            agentName: document.getElementById("AgentName").value
                ? document.getElementById("AgentName").value
                : "",
            agentPhone: "",
            agentAddress: "",
            agentAllocationId: document.getElementById("AllocationId").value
                ? document.getElementById("AllocationId").value
                : "",
            agentPreferenceMondayHours: document.getElementById(
                "AgentPreferenceMondayHours"
            ).value
                ? document.getElementById("AgentPreferenceMondayHours").value
                : "",
            agentPreferenceTuesdayHours: document.getElementById(
                "AgentPreferenceTuesdayHours"
            ).value
                ? document.getElementById("AgentPreferenceTuesdayHours").value
                : "",
            agentPreferenceWednesdayHours: document.getElementById(
                "AgentPreferenceWednesdayHours"
            ).value
                ? document.getElementById("AgentPreferenceWednesdayHours").value
                : "",
            agentPreferenceThursdayHours: document.getElementById(
                "AgentPreferenceThursdayHours"
            ).value
                ? document.getElementById("AgentPreferenceThursdayHours").value
                : "",
            agentPreferenceFridayHours: document.getElementById(
                "AgentPreferenceFridayHours"
            ).value
                ? document.getElementById("AgentPreferenceFridayHours").value
                : "",
            agentOperatingHours: this.SetOperatingHoursByDay(
                document.getElementById("AgentAppointmentStartDate").value
            ),
            appointmentPhone: "",
            isAppointmentstackingAllow:
                document.getElementById("IsAppointmentstackingAllow").value === "True"
                    ? true
                    : false,
            agentAppointmentBusySlotsOriginal: document.getElementById(
                "AgentAppointmentBusy"
            ).value
                ? this.parseBusyAppointmentSlots(
                    document.getElementById("AgentAppointmentBusy").value
                )
                : [],
            agentAppointmentBusySlotsUpdated: [],
            appointmentLocation: "",
            movingDateString: format(
                new Date(
                    document.getElementById("MoveDate").value
                        ? document.getElementById("MoveDate").value
                        : +new Date() + 86400000
                ),
                "MM/dd/yyyy"
            ),
            movingToAddrComponent: {
                MovingToInput: document.getElementById("MovingToInput").value
                    ? document.getElementById("MovingToInput").value
                    : "",
                MovingToAddress: document.getElementById("MovingToAddress").value
                    ? document.getElementById("MovingToAddress").value
                    : "",
                MovingToCity: document.getElementById("MovingToCity").value
                    ? document.getElementById("MovingToCity").value
                    : "",
                MovingToState: document.getElementById("MovingToState").value
                    ? document.getElementById("MovingToState").value
                    : "",
                MovingToZip: document.getElementById("MovingToZip").value
                    ? document.getElementById("MovingToZip").value
                    : "",
                MovingToCountryCode: document.getElementById("MovingToCountryCode")
                    .value
                    ? document.getElementById("MovingToCountryCode").value
                    : "",
            },
            movingFromAddrComponent: {
                MovingFromInput: document.getElementById("MovingFromInput").value
                    ? document.getElementById("MovingFromInput").value
                    : "",
                MovingFromAddress: document.getElementById("MovingFromAddress").value
                    ? document.getElementById("MovingFromAddress").value
                    : "",
                MovingFromCity: document.getElementById("MovingFromCity").value
                    ? document.getElementById("MovingFromCity").value
                    : "",
                MovingFromState: document.getElementById("MovingFromState").value
                    ? document.getElementById("MovingFromState").value
                    : "",
                MovingFromZip: document.getElementById("MovingFromZip").value
                    ? document.getElementById("MovingFromZip").value
                    : "",
                MovingFromCountryCode: document.getElementById("MovingFromCountryCode")
                    .value
                    ? document.getElementById("MovingFromCountryCode").value
                    : "",
            },
            instaQuotePriceRange: "",
            isLoadingAgain: false,
            formErrors: {
                movingFromStreetErrMsg: movingFromStreetErrMsgInit,
                movingToStreetErrMsg: "Please Enter Moving To Location.",
                contactNameErrMsg: "Please Enter Contact Name.",
                contactEmailErrMsg: "Please Enter Email Address.",
                contactPhoneErrMsg: "Please Enter Phone Number.",
            },
            referralCode: document.getElementById("RefferalCode").value,
            vendorName: document.getElementById("VendorName").value,
            vendorParms: document.getElementById("VendorParms").value,
            vendorId: document.getElementById("VendorId").value,
            deviceType: document.getElementById("DeviceType").value,
            prevPageUrlReferral: document.getElementById("PrevPageUrlReferrer").value,
            verificationToken: document.getElementsByName(
                "__RequestVerificationToken"
            )[0].value,
            movingFromValid: movingFromValidInit,
            movingToValid: true,
            houseSizeValid: false,
            movingVehicleValid: false,
            contactNameValid: true,
            contactEmailValid: true,
            contactPhoneValid: true,
            appointmentTypeValid: false,
            step1FormValid: step1FormValidInit,
            step2FormValid:
                document.getElementById("IsDataByLMPID").value === "True" ||
                    document.getElementById("errorMsg").value
                    ? true
                    : false,
            step3FormValid:
                document.getElementById("IsDataByLMPID").value === "True" ||
                    document.getElementById("errorMsg").value
                    ? true
                    : false,
            step5FormValid: false,
            initForm: true,
            initStep3From: true,
            isLocalMove: false,
            instaQuoteApiSuccess: false,
            validationFields: [
                "movingFromStreet",
                "movingToStreet",
                "houseSize",
                "contactName",
                "contactEmail",
                "contactPhone",
            ],
            isOutOfAreaMove: false,
            isCAS: false,
            //CAS Appointment Details Fields
            salesPersonID: "",
            salesPersonName: "",
            calendarUserName: "",
            calendarURL: "",
        };
    }

    // proceed to next step
    nextStep = () => {
        const { step } = this.state;
        this.setState({
            step: step + 1,
        });
    };

    // go back to previous step
    prevStep = () => {
        const { step } = this.state;
        this.setState({
            step: step - 1,
        });
    };

    setFirstDay() {
        const date = new Date(+new Date() + 2 * 86400000);
        const dayOfWeek = date.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
            // If it's a weekend, calculate the next business day
            const nextBusinessDay = new Date(date);
            nextBusinessDay.setDate(date.getDate() + (dayOfWeek === 0 ? 1 : 2));
            return nextBusinessDay;
        } else {
            return date;
        }
    }

    // handle fields change
    handleChange = (input) => (e) => {
        const value = e.target.value;
        this.setState(
            {
                [input]: value,
            },
            () => {
                this.validateField(input, value);
                if (input === "contactPhone")
                    this.setState({
                        [input]: this.phoneNumberFormatter(value),
                    });
            }
        );
    };

    handleDateChange = (date) => {
        this.setState({
            movingDate: date,
            movingDateString: format(date, "MM/dd/yyyy"),
        });
    };

    handleAptDateChange = (date) => {
        var isExist = false;
        let timeSlotsForSelectedDate = [];
        for (
            var i = 0;
            i < this.state.agentAppointmentBusySlotsOriginal.length;
            i++
        ) {
            if (
                this.state.agentAppointmentBusySlotsOriginal[i].getDate() ===
                date.getDate()
            ) {
                isExist = true;
                timeSlotsForSelectedDate.push(
                    this.state.agentAppointmentBusySlotsOriginal[i]
                );
            }
        }
        //Get Operating hours by selected day
        let hourArray = this.SetOperatingHoursByDay(date.toString());
        console.log(timeSlotsForSelectedDate);
        console.log(hourArray);

        this.setState({
            appointmentDate: date,
            appointmentTime: date,
            appointmentDateString: format(date, "MM/dd/yyyy"),
            agentAppointmentBusySlotsUpdated:
                isExist && !this.state.isAppointmentstackingAllow
                    ? timeSlotsForSelectedDate
                    : [],
            agentOperatingHours: hourArray,
        });
    };

    handleTimeChange = (date) => {
        this.setState({
            appointmentTime: date,
            appointmentTimeString: format(date, "hh:mm aa"),
        });
    };

    handleCheck = (e) => {
        this.setState({
            checked: e.target.checked,
        });
    };

    handleLoading = () => {
        this.setState({
            isLoading: false,
        });
    };

    jumpToStep = (step) => {
        this.setState({
            step: step,
        });
    };

    triggerStep1Validation = () => {
        //alert("validation triggered !");
        let validationFields = this.state.validationFields;

        validationFields.forEach((element) => {
            this.validateField(element, document.getElementById(element).value);
        });
    };

    handleValidationFields = (step) => {
        switch (step) {
            case 1:
                this.setState({
                    movingFromValid: false,
                    movingToValid: false,
                });
                break;

            case 3:
                this.setState({
                    contactNameValid: false,
                    contactEmailValid: false,
                    contactPhoneValid: false,
                });
                break;

            default:
                break;
        }
    };

    handleInstaQuotePriceRance = (data, moveToNextStep) => {
        try {
            this.setState(
                {
                    instaQuotePriceRange:
                        "$" +
                        data.result.Average.LowPrice +
                        " - $" +
                        data.result.Average.HighPrice,
                    isLoadingAgain: true,
                    instaQuoteApiSuccess: true,
                },
                moveToNextStep ? this.handleLocalMove : null
            );
        } catch (err) {
            this.handleInstaQuoteError();
        }
    };

    handleInstaQuoteError = (data) => {
        this.setState(
            {
                instaQuotePriceRange: "Please Call",
                isLoadingAgain: true,
                instaQuoteApiSuccess: false,
            },
            this.handleLocalMove
        );
    };

    handleAgentAppointmentDetailFromApi = (data) => {
        if (data.Success) {
            var busy = data.isCAS
                ? data.casCalendarDetails.busy
                : data.aasCalendarDetails.busy;
            var holidays = data.isCAS
                ? data.casCalendarDetails.nextHolidays
                : data.aasCalendarDetails.nextHolidays;
            var startDate = data.isCAS
                ? data.casCalendarDetails.startDate
                : data.aasCalendarDetails.startDate;

            //get Agent Hour Preferences

            //Monday
            var AgentPreferenceMondayHours = data.isCAS
                ? data.casCalendarDetails.AgentPreferenceMondayHours
                : data.aasCalendarDetails.AgentPreferenceMondayHours;

            document.getElementById("AgentPreferenceMondayHours").value = AgentPreferenceMondayHours;

            //Tues
            var AgentPreferenceTuesdayHours = data.isCAS
                ? data.casCalendarDetails.AgentPreferenceTuesdayHours
                : data.aasCalendarDetails.AgentPreferenceTuesdayHours;

            document.getElementById("AgentPreferenceTuesdayHours").value = AgentPreferenceTuesdayHours;

            //Wed
            var AgentPreferenceWednesdayHours = data.isCAS
                ? data.casCalendarDetails.AgentPreferenceWednesdayHours
                : data.aasCalendarDetails.AgentPreferenceWednesdayHours;

            document.getElementById("AgentPreferenceWednesdayHours").value = AgentPreferenceWednesdayHours;


            //Thurs
            var AgentPreferenceThursdayHours = data.isCAS
                ? data.casCalendarDetails.AgentPreferenceThursdayHours
                : data.aasCalendarDetails.AgentPreferenceThursdayHours;

            document.getElementById("AgentPreferenceThursdayHours").value = AgentPreferenceThursdayHours;

            //Friday
            var AgentPreferenceFridayHours = data.isCAS
                ? data.casCalendarDetails.AgentPreferenceFridayHours
                : data.aasCalendarDetails.AgentPreferenceFridayHours;

            document.getElementById("AgentPreferenceFridayHours").value = AgentPreferenceFridayHours;


            //let's set the AgentappointmentTime
            let hourArray = this.SetOperatingHoursByDay(startDate.toString());

            console.log(hourArray);
            console.log(hourArray.map(t => t instanceof Date));


            let busyAppointmentSlots = this.parseBusyAppointmentSlots(busy);
            const holidaysSlots = (holidays || "")
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
                .map((s) => new Date(s))
                .map((d) => new Date(d.getFullYear(), d.getMonth(), d.getDate())) // start of day
                .filter((d) => !isNaN(d.getTime()));

            this.setState(
                {
                    isCAS: data.isCAS,
                    agentCode: data.agentCode,
                    agentName: data.agentName,
                    agentPhone: data.agentPhone,
                    agentAddress: data.agentAddress,
                    agentAllocationId: data.allocationID,
                    agentAppointmentStartDate: new Date(startDate),
                    agentAppointmentNextHoliday: holidaysSlots,
                    agentOperatingHours: hourArray,
                    isAppointmentstackingAllow:
                        data.aasCalendarDetails.aasStackAppointments,
                    agentAppointmentBusySlotsOriginal: busyAppointmentSlots,
                    agentAppointmentBusySlotsUpdated: [],
                    salesPersonName: data.casCalendarDetails.salesPersonName,
                    salesPersonID: data.casCalendarDetails.salesPersonID,
                    calendarUserName: data.casCalendarDetails.calendarUserName,
                    calendarURL: data.casCalendarDetails.calendarURL,
                },
                this.handleLocalMove
            );
        } else {
            this.setState({
                isOutOfAreaMove: true,
            });
            this.jumpToStep(5);
        }
    };



    //   normalizeBusy = (busy) => {
    //     if (!busy) return [];

    //     if (Array.isArray(busy)) {
    //       // CAS case: already an array
    //       return busy;
    //     }

    //     // AAS case: comma‑separated string
    //     if (typeof busy === "string") {
    //       return busy
    //         .split(",")
    //         .map((s) => s.trim())
    //         .filter(Boolean);
    //     }

    //     return [];
    //   };

    handleLeadSubmission = (data) => {
        this.jumpToStep(7);
    };
    handleOnlineBookingFinalResponse = (success) => {
        console.log("Submission Status: " + success);
        if (!success) {
            this.setState({
                errorMsg: "There is something wrong with the appointment booking",
            });
        }
    };
    handleIsLoadingFlag = (flag) => {
        this.setState({
            isLoadingAgain: flag,
        });
    };

    handleMovingFromValidation = () => {
        this.setState({
            movingFromValid: false,
        });
    };

    handleMovingToValidation = () => {
        this.setState({
            movingToValid: false,
        });
    };

    handleLocalMove() {
        let diff = this.state.movingDate - new Date();
        let isMoveWithin7Days = diff <= 604800000; //Diff in 7 Days in millisecond
        if (!this.state.isLocalMove || !isMoveWithin7Days) {
            this.jumpToStep(5);
        }
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let movingFromValid = this.state.movingFromValid;
        let movingToValid = this.state.movingToValid;
        let houseSizeValid = this.state.houseSizeValid;
        let movingVehicleValid = this.state.movingVehicleValid;
        let contactNameValid = this.state.contactNameValid;
        let contactEmailValid = this.state.contactEmailValid;
        let contactPhoneValid = this.state.contactPhoneValid;
        let appointmentTypeValid = this.state.appointmentTypeValid;
        let initForm = this.state.initForm;
        let initStep3From = this.state.initStep3From;

        switch (fieldName) {
            case "movingFromStreet":
                movingFromValid = value.length >= 1;
                initForm = false;
                //fieldValidationErrors.movingFromStreetErrMsg = movingFromValid ? '' : ' is required';
                break;

            case "movingToStreet":
                movingToValid = value.length >= 1;
                initForm = false;
                //fieldValidationErrors.movingToStreetErrMsg = movingToValid ? '' : ' is required';
                break;

            case "houseSize":
                houseSizeValid = value.length >= 1;
                break;

            case "movingVehicle":
                movingVehicleValid = value.length >= 1;
                break;

            case "appointmentType":
                appointmentTypeValid = value.length >= 1;
                break;

            case "contactName":
                contactNameValid = value.length >= 1;
                fieldValidationErrors.contactNameErrMsg = contactNameValid
                    ? ""
                    : "Please Enter Contact Name.";
                initStep3From = false;
                break;

            case "contactEmail":
                if (value.length < 1) {
                    contactEmailValid = false;
                    fieldValidationErrors.contactEmailErrMsg = contactEmailValid
                        ? ""
                        : "Please Enter Email Address.";
                } else if (
                    !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
                ) {
                    contactEmailValid = false;
                    fieldValidationErrors.contactEmailErrMsg = contactEmailValid
                        ? ""
                        : "Email Address is Invalid !";
                } else {
                    contactEmailValid = true;
                }
                initStep3From = false;
                break;

            case "contactPhone":
                // if (value.length < 1) {
                //   contactPhoneValid = false;
                //   fieldValidationErrors.contactPhoneErrMsg = contactPhoneValid ? '' : 'Please Enter Phone Number.';
                // }
                // else if (value.length > 10) {
                //   contactPhoneValid = false;
                //   fieldValidationErrors.contactPhoneErrMsg = contactPhoneValid ? '' : 'Phone Number Needs to be 10 Digits';
                // }
                // else if (isNaN(+value)) {
                //   contactPhoneValid = false;
                //   fieldValidationErrors.contactPhoneErrMsg = contactPhoneValid ? '' : 'Non Digit is not allowed.';
                // }
                // else {
                //   contactPhoneValid = true;
                // }
                contactPhoneValid = true;
                initStep3From = false;
                break;

            default:
                break;
        }

        this.setState(
            () => ({
                formErrors: fieldValidationErrors,
                movingFromValid: movingFromValid,
                movingToValid: movingToValid,
                houseSizeValid: houseSizeValid,
                initForm: initForm,
            }),
            this.validateStep1Form
        );

        this.setState(
            () => ({
                formErrors: fieldValidationErrors,
                houseSizeValid: houseSizeValid,
                movingVehicleValid: movingVehicleValid,
            }),
            this.validateStep2Form
        );

        this.setState(
            () => ({
                formErrors: fieldValidationErrors,
                contactNameValid: contactNameValid,
                contactEmailValid: contactEmailValid,
                contactPhoneValid: contactPhoneValid,
                initStep3From: initStep3From,
            }),
            this.validateStep3Form
        );

        this.setState(
            () => ({
                appointmentTypeValid: appointmentTypeValid,
            }),
            this.validateStep5Form
        );
    }

    validateStep1Form() {
        this.setState({
            step1FormValid: this.state.movingToValid && this.state.movingFromValid,
        });
    }

    validateStep2Form() {
        this.setState({
            step2FormValid:
                this.state.houseSizeValid && this.state.movingVehicleValid,
        });
    }

    validateStep3Form() {
        if (!this.state.initStep3From) {
            this.setState({
                step3FormValid:
                    this.state.contactNameValid &&
                    this.state.contactEmailValid &&
                    this.state.contactPhoneValid,
            });
        }
    }

    validateStep5Form() {
        this.setState({ step5FormValid: this.state.appointmentTypeValid });
    }

    errorClass(error) {
        return error.length === 0 ? "" : "has-error";
    }

    validateMovingFromIncompleteAddress = () => {
        if (!this.state || !this.state.movingFromStreet) {
            console.log("Address is missing.");
            return false;
        }

        const address = this.state.movingFromStreet.trim();
        const regex = /\b(?:\d+\s*[A-Za-z]+|[A-Za-z]+\s*\d+)\b/;

        if (!regex.test(address)) {
            console.log("Invalid address: must contain both letters and numbers.");
            return false;
        }

        console.log("Valid address.");
        return true;
    };

    handleIncompleteMovingFromAddress = () => {
        this.setState({ movingFromValid: false });
    };

    handleStep2ValidationAfterCompleteAddr = () => {
        this.setState({ step2FormValid: true });
    };

    SetOperatingHoursByDay(dateValue) {
        let date = new Date(dateValue);
        let day = date.getDay();
        let operatingHourArray = [];
        console.log(date);
        switch (day) {
            case 1:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceMondayHours").value,
                    date.toString()
                );
                break;
            case 2:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceTuesdayHours").value,
                    date.toString()
                );
                break;
            case 3:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceWednesdayHours").value,
                    date.toString()
                );
                break;
            case 4:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceThursdayHours").value,
                    date.toString()
                );

                break;
            case 5:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceFridayHours").value,
                    date.toString()
                );
                break;
            default: //if Sunday or Saturday apply operating hours for Monday
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceMondayHours").value,
                    date.toString()
                );
                break;
        }

        let agentAppointmentBusySlotsOriginalArray = this.parseBusyAppointmentSlots(
            document.getElementById("AgentAppointmentBusy").value
        );
        let busyTimeSlotsForSelectedDate = [];
        let isStackingAllow =
            document.getElementById("IsAppointmentstackingAllow").value === "True"
                ? true
                : false;
        for (var i = 0; i < agentAppointmentBusySlotsOriginalArray.length; i++) {
            if (
                agentAppointmentBusySlotsOriginalArray[i].getDate() === date.getDate()
            ) {
                busyTimeSlotsForSelectedDate.push(
                    agentAppointmentBusySlotsOriginalArray[i]
                );
            }
        }

        //Remove busy hour(s) from selected day based on is stacking appointment allowed AND busyTimeSlotsForSelectedDate array is not empty
        if (busyTimeSlotsForSelectedDate.length > 0 && !isStackingAllow) {
            operatingHourArray = operatingHourArray.filter((s) =>
                busyTimeSlotsForSelectedDate.every((e) => e.toString() !== s.toString())
            );
        }

        //console.log("result after fillered (first time) -------");
        //console.log(operatingHourArray);

        return operatingHourArray;
    }

    parseOperatingHours(Hourdata, dateValue) {

        if (!Hourdata) return [];

        const allowedTimes = Hourdata
            .split(",")
            .map(h => parseFloat(h.trim()))
            .map(h => {
                const hour = Math.floor(h);
                const minutes = h % 1 === 0.5 ? 30 : 0;

                // IMPORTANT: always start with a fresh Date()
                let d = new Date(dateValue);
                d = setMinutes(d, minutes);
                d = setHours(d, hour);

                return d; // <-- MUST be a Date object
            });

        return allowedTimes;
    }

    parseBusyAppointmentSlots(busy) {
        if (!busy) return [];
        let parsedSlotData = [];
        let finalSlotData = [];
        let slotArr = [];

        if (!Array.isArray(busy) && typeof busy === "string") {
            slotArr = busy.split(",");
        }
        else {
            slotArr = busy;
        }

        slotArr.forEach((element) => {
            var a = new Date(element);
            var b = a.toString();
            parsedSlotData.push(b);
        });

        let uniqueChars = [];
        parsedSlotData.forEach((element) => {
            if (!uniqueChars.includes(element)) {
                uniqueChars.push(element);
            }
        });

        uniqueChars.forEach((element) => {
            finalSlotData.push(new Date(element));
        });
        return finalSlotData;
    }






    updateInputVal(input, selected) {
        this.setState({
            [input]: selected.formatted_address,
        });

        var googleAutoCompleteReadableJsonFormat =
            this.convertGoogleApiComponentToReadableJson(selected, input);
        if (input === "movingFromStreet") {
            this.setState({
                movingFromAddrComponent: {
                    MovingFromInput: selected.formatted_address,
                    MovingFromAddress: googleAutoCompleteReadableJsonFormat.addy,
                    MovingFromCity: googleAutoCompleteReadableJsonFormat.city,
                    MovingFromState: googleAutoCompleteReadableJsonFormat.state,
                    MovingFromZip: googleAutoCompleteReadableJsonFormat.zip,
                    MovingFromCountryCode: googleAutoCompleteReadableJsonFormat.cntryCode,
                },
            });

            //console.log(this.state.movingFromAddrComponent);
        }

        if (input === "movingToStreet") {
            this.setState(
                {
                    movingToAddrComponent: {
                        MovingToInput: selected.formatted_address,
                        MovingToAddress: googleAutoCompleteReadableJsonFormat.addy,
                        MovingToCity: googleAutoCompleteReadableJsonFormat.city,
                        MovingToState: googleAutoCompleteReadableJsonFormat.state,
                        MovingToZip: googleAutoCompleteReadableJsonFormat.zip,
                        MovingToCountryCode: googleAutoCompleteReadableJsonFormat.cntryCode,
                    },
                },
                this.determineMoveType
            );

            //console.log(this.state.movingToAddrComponent);
        }
    }

    determineMoveType() {
        this.setState({
            isLocalMove:
                this.state.movingFromAddrComponent.MovingFromState ===
                this.state.movingToAddrComponent.MovingToState,
        });
    }

    convertGoogleApiComponentToReadableJson(place, input) {
        var components = place.address_components;
        var comp, township, county, sep, streetNumber, route;
        var resultJson = {};

        if (!components) {
            console.log("components error: ");
            console.log(components);
            return resultJson;
        }

        for (var c = 0; c < components.length; ++c) {
            comp = components[c];

            if (comp.types.indexOf("street_number") > -1) {
                streetNumber = comp.long_name;
            }
            if (comp.types.indexOf("route") > -1) {
                route = comp.short_name;
            }
            if (
                comp.types.indexOf("locality") > -1 &&
                comp.types.indexOf("political") > -1
            ) {
                resultJson.city = comp.long_name;
            }
            if (
                comp.types.indexOf("administrative_area_level_3") > -1 &&
                comp.types.indexOf("political") > -1
            ) {
                township = comp.long_name;
            }
            if (
                comp.types.indexOf("administrative_area_level_2") > -1 &&
                comp.types.indexOf("political") > -1
            ) {
                county = comp.long_name;
            }
            if (
                comp.types.indexOf("administrative_area_level_1") > -1 &&
                comp.types.indexOf("political") > -1
            ) {
                resultJson.state = comp.short_name;
            }
            if (comp.types.indexOf("postal_code") > -1) {
                resultJson.zip = comp.short_name.replace(/\s/g, "");
            }
            if (comp.types.indexOf("country") > -1) {
                resultJson.cntryCode = comp.short_name;
            }
        }

        if (!resultJson.city) {
            resultJson.city = township || county || "";
        }

        sep = streetNumber && route ? " " : "";

        streetNumber = streetNumber || "";
        route = route || "";

        resultJson.addy = streetNumber + sep + route;

        resultJson.zip = "";

        if (!resultJson.zip && place.geometry && place.geometry.location) {
            // autocomplete failed to return a zip code. Use lat/long to get one
            var location = place.geometry.location,
                lat = location.lat(),
                lng = location.lng();

            Geocode.setApiKey("AIzaSyAhGzSn1R46p94ApfqMiBHVHzi8IeMqhoU");

            Geocode.fromLatLng(lat, lng).then(
                (response) => {
                    if (response.results.length >= 0) {
                        console.log(response.results);

                        for (var i = 0; i < response.results.length; i++) {
                            if (response.results[i]) {
                                var cmpts = response.results[i].address_components;
                                var breakOut = false;
                                for (var c = 0; c < cmpts.length; ++c) {
                                    comp = cmpts[c];

                                    if (comp.types.indexOf("postal_code") > -1) {
                                        this.updateInputZipAfterGeoCode(
                                            input,
                                            comp.short_name.replace(/\s/g, "")
                                        );
                                        //resultJson.zip = comp.short_name.replace(/\s/g, "");
                                        //window.alert(resultJson.zip);
                                        breakOut = true;
                                        break;
                                        //console.log('zip gets ' + comp.short_name)
                                    }
                                }

                                if (breakOut) {
                                    //this.validateLocationInterpretation();
                                    break;
                                }
                            }
                        }
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        }
        //else validateLocationInterpretation();
        //console.log(zipper);
        return resultJson;
    }

    updateInputZipAfterGeoCode(input, zip) {
        if (input === "movingFromStreet") {
            var oldVal = this.state.movingFromAddrComponent;

            this.setState({
                movingFromAddrComponent: {
                    MovingFromInput: oldVal.MovingFromInput,
                    MovingFromAddress: oldVal.MovingFromAddress,
                    MovingFromCity: oldVal.MovingFromCity,
                    MovingFromState: oldVal.MovingFromState,
                    MovingFromZip: zip,
                    MovingFromCountryCode: oldVal.MovingFromCountryCode,
                },
            });

            //    console.log(this.state.movingFromAddrComponent);
        }

        if (input === "movingToStreet") {
            oldVal = this.state.movingToAddrComponent;

            this.setState({
                movingToAddrComponent: {
                    MovingToInput: oldVal.MovingToInput,
                    MovingToAddress: oldVal.MovingToAddress,
                    MovingToCity: oldVal.MovingToCity,
                    MovingToState: oldVal.MovingToState,
                    MovingToZip: zip,
                    MovingToCountryCode: oldVal.MovingToCountryCode,
                },
            });

            //    console.log(this.state.movingToAddrComponent);
        }
    }

    formatPhoneNumber(value) {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, "");
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )}-${phoneNumber.slice(6, 10)}`;
    }

    phoneNumberFormatter(value) {
        const formattedInputValue = this.formatPhoneNumber(value);
        console.log(formattedInputValue);
        return formattedInputValue;
    }

    render() {
        const { step, isFilled } = this.state;
        const {
            LeadId,
            isDataByLMPID,
            isIncompleteAddress,
            errorMsg,
            movingFromStreet,
            movingFromUnit,
            movingToStreet,
            movingToUnit,
            movingDate,
            houseSize,
            movingVehicle,
            contactName,
            contactEmail,
            contactPhone,
            appointmentType,
            appointmentDate,
            appointmentTime,
            appointmentPhone,
            appointmentLocation,
            movingToAddrComponent,
            movingFromAddrComponent,
            movingDateString,
            instaQuotePriceRange,
            isLoadingAgain,
            appointmentDateString,
            appointmentTimeString,
            agentAppointmentStartDate,
            agentAppointmentNextHoliday,
            agentCode,
            agentName,
            agentPhone,
            agentAddress,
            agentAllocationId,
            agentPreferenceMondayHours,
            agentPreferenceTuesdayHours,
            agentPreferenceWednesdayHours,
            agentPreferenceThursdayHours,
            agentPreferenceFridayHours,
            agentOperatingHours,
            isAppointmentstackingAllow,
            agentAppointmentBusySlotsOriginal,
            agentAppointmentBusySlotsUpdated,
            referralCode,
            vendorName,
            vendorParms,
            vendorId,
            deviceType,
            prevPageUrlReferral,
            verificationToken,
            step1FormValid,
            step2FormValid,
            step3FormValid,
            formErrors,
            movingFromValid,
            movingToValid,
            contactNameValid,
            contactEmailValid,
            contactPhoneValid,
            initForm,
            initStep3From,
            isLocalMove,
            isOutOfAreaMove,
            isCAS,
            salesPersonID,
            salesPersonName,
            calendarUserName,
            calendarURL,
        } = this.state;
        const values = {
            LeadId,
            isDataByLMPID,
            isIncompleteAddress,
            errorMsg,
            movingFromStreet,
            movingFromUnit,
            movingToStreet,
            movingToUnit,
            movingDate,
            houseSize,
            movingVehicle,
            contactName,
            contactEmail,
            contactPhone,
            appointmentType,
            appointmentDate,
            appointmentTime,
            appointmentPhone,
            appointmentLocation,
            movingToAddrComponent,
            movingFromAddrComponent,
            movingDateString,
            instaQuotePriceRange,
            isLoadingAgain,
            appointmentDateString,
            appointmentTimeString,
            agentAppointmentStartDate,
            agentAppointmentNextHoliday,
            agentCode,
            agentName,
            agentPhone,
            agentAddress,
            agentAllocationId,
            agentPreferenceMondayHours,
            agentPreferenceTuesdayHours,
            agentPreferenceWednesdayHours,
            agentPreferenceThursdayHours,
            agentPreferenceFridayHours,
            agentOperatingHours,
            isAppointmentstackingAllow,
            agentAppointmentBusySlotsOriginal,
            agentAppointmentBusySlotsUpdated,
            referralCode,
            vendorName,
            vendorParms,
            vendorId,
            deviceType,
            prevPageUrlReferral,
            verificationToken,
            step1FormValid,
            step2FormValid,
            step3FormValid,
            formErrors,
            movingFromValid,
            movingToValid,
            contactNameValid,
            contactEmailValid,
            contactPhoneValid,
            initForm,
            initStep3From,
            isLocalMove,
            isOutOfAreaMove,
            isCAS,
            salesPersonID,
            salesPersonName,
            calendarUserName,
            calendarURL,
        };

        let { activeStep } = this.props;

        const container = document.getElementById("online-booking");

        switch (step) {
            case 1:
                activeStep = 1;
                return ReactDOM.createPortal(
                    <div>
                        <WindowWarning enable />
                        <Progress
                            values={values}
                            activeStep={activeStep}
                            isFilled={isFilled}
                            jumpToStep={this.jumpToStep}
                        />
                        <Location
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            handleChange={this.handleChange}
                            values={values}
                            updateInputValue={(input, selected) =>
                                this.updateInputVal(input, selected)
                            }
                            triggerValidation={this.triggerStep1Validation}
                            handleValidationFields={this.handleValidationFields}
                            jumpToStep={this.jumpToStep}
                            validateMovingFromIncompleteAddress={
                                this.validateMovingFromIncompleteAddress
                            }
                            handleIncompleteMovingFromAddress={
                                this.handleIncompleteMovingFromAddress
                            }
                            handleStep2ValidationAfterCompleteAddr={
                                this.handleStep2ValidationAfterCompleteAddr
                            }
                        />
                        {/* {this.setGoogleApi()} */}
                    </div>,
                    container
                );
            case 2:
                activeStep = 2;
                return ReactDOM.createPortal(
                    <div>
                        <WindowWarning enable />
                        <Progress
                            values={values}
                            activeStep={activeStep}
                            jumpToStep={this.jumpToStep}
                        />
                        <Move
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            handleChange={this.handleChange}
                            handleDateChange={this.handleDateChange}
                            values={values}
                        />
                    </div>,
                    container
                );
            case 3:
                activeStep = 3;
                return ReactDOM.createPortal(
                    <div>
                        <WindowWarning enable />
                        <Progress
                            values={values}
                            activeStep={activeStep}
                            jumpToStep={this.jumpToStep}
                        />
                        <Contact
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            handleChange={this.handleChange}
                            values={values}
                            handleValidationFields={this.handleValidationFields}
                            handleInstaQuotePriceRance={this.handleInstaQuotePriceRance}
                            handleAgentAppointmentDetailFromApi={
                                this.handleAgentAppointmentDetailFromApi
                            }
                            triggerValidation={this.triggerStep1Validation}
                            handleLeadSubmission={this.handleLeadSubmission}
                            handlePhoneFormat={this.phoneNumberFormatter}
                        />
                    </div>,
                    container
                );
            case 4:
                return ReactDOM.createPortal(
                    <div>
                        <WindowWarning enable />
                        <Progress values={values} jumpToStep={this.jumpToStep} />
                        <Loading
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            loadingText="Calculating..."
                            isFinalStep={false}
                            values={values}
                        />
                    </div>,
                    container
                );
            case 5:
                activeStep = 5;
                return ReactDOM.createPortal(
                    <div>
                        <Progress
                            values={values}
                            activeStep={activeStep}
                            jumpToStep={this.jumpToStep}
                        />
                        <WindowWarning enable />
                        <Quote
                            prevStep={this.prevStep}
                            nextStep={this.nextStep}
                            handleChange={this.handleChange}
                            handleAptDateChange={this.handleAptDateChange}
                            handleTimeChange={this.handleTimeChange}
                            handleLeadSubmission={this.handleLeadSubmission}
                            values={values}
                            handleOnlineBookingFinalResponse={(leadSuccess) =>
                                this.handleOnlineBookingFinalResponse(leadSuccess)
                            }
                        />
                    </div>,
                    container
                );
            case 6:
                activeStep = 6;
                return ReactDOM.createPortal(
                    <div>
                        <WindowWarning enable />
                        <Loading
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            loadingText="Booking Your Appointment...."
                            isFinalStep={true}
                            values={values}
                        />
                    </div>,
                    container
                );
            case 7:
                return ReactDOM.createPortal(
                    <div>
                        <Confirm values={values} />
                    </div>,
                    container
                );
            default:
            //do nothing
        }
    }
}
